import React from 'react';
import { Icon, IconName } from '@usealloy/component-library';
import {
  defaultOnDeleteAction, defaultOnSwapAction, defaultOnUpdateAction, defaultOnViewListAction,
} from './helpers';


export const OnDeleteDefaults = {
  label: 'Delete',
  Icon: <Icon icon={IconName.Trash} color="var('--cl-red-600)" />,
  style: { color: 'var(--cl-red-600)' },
  onSelect: defaultOnDeleteAction,
};

export const OnSwapDefaults = {
  label: 'Swap Tag',
  Icon: null,
  style: null,
  onSelect: defaultOnSwapAction,
};

export const OnUpdateDefaults = {
  label: 'Update to active version',
  Icon: null,
  style: null,
  onSelect: defaultOnUpdateAction,
};

export const OnViewListDefaults = {
  label: 'View List',
  Icon: null,
  style: null,
  onSelect: defaultOnViewListAction,
};
